import i18n from "@/i18n.js";
import MonitoringElementType from "@/constants/monitoring-elements/MonitoringElementType";
import MonitoringElementsService from "@/services/MonitoringElementsService";
import Controllers from "@/controllers/index";
import store from "@/stores/store.js";
import { SET } from "@/stores/CommumActionTypes";
import { GetWindParkSelect } from "@/stores/actions/WindParkSelect";

/**
 * @summary Cria um objeto do tree menu vazio.
 * @type {Function}
 * @returns {Json} Objeto do tree menu vazio.
 */
const EmptyToolBarMenuFactory = function()
{
	return {
		id:   0,
		name: "",
		type: "",
	};
};

/**
* @summary - Cria um monitoringElement do tipo Home, exclusivo do tree menu.
* @returns {object} - MonitoringElement do tipo Home.
*/
const CreateHomeItem = () =>
{
	const homeItem = EmptyToolBarMenuFactory();
	homeItem.id = -1;
	homeItem.name = i18n.t("Buttons.Home");
	homeItem.type = MonitoringElementType.Home;
	return homeItem;
};

/**
 * Cria um monitoringElement do tipo Settings, exclusivo do tree menu.
 *
 * @returns {object} MonitoringElement do tipo Settings.
 */
const CreateSettingsItem = () =>
{
	const settingsItem = EmptyToolBarMenuFactory();
	settingsItem.id = -2;
	settingsItem.name = i18n.t("Buttons.Settings");
	settingsItem.type = MonitoringElementType.Settings;
	return settingsItem;
};

/**
 * Cria um MonitoringElement do tipo Notifications, exclusivo do tree menu.
 * @returns {object} - MonitoringElement do tipo Notifications.
 */
const CreateNotificationsItem = () =>
{
	const NotificationsItem = EmptyToolBarMenuFactory();
	NotificationsItem.id = -3;
	NotificationsItem.name = i18n.t("Buttons.Alarms");
	NotificationsItem.type = MonitoringElementType.Notifications;
	return NotificationsItem;
};

/**
 * @summary Cria os itens da treeview da toolbar.
 * @param {Array} monitoringElements
 */
const CreateToolBarMenu = function(monitoringElements)
{
	const homeToolBarItem = CreateHomeItem();
	const notificationsToolBarItem = CreateNotificationsItem();
	const monitoringElementsMenuItens = MonitoringElementsService.CreateMonitoringElementsTreeMenu(monitoringElements);

	monitoringElementsMenuItens.forEach((complex) =>
	{
		complex.monitoringElementChild.forEach((park) =>
		{
			park.monitoringElementChild.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
		});
	});

	const menu = [ homeToolBarItem, ...monitoringElementsMenuItens, notificationsToolBarItem ];
	store.dispatch(GetWindParkSelect, monitoringElementsMenuItens);

	return menu;
};

/**
 * @summary Cria o menu lateral da toolbar
 * @param {Numbr - String} companyId
 * @returns {Array} Menu lateral da toolbar
 */
const GetToolBarTreeMenu = async function(companyId = 0)
{
	let resp = {};
	let toolbarMonitoringElements = [];
	let menu = [];

	// Se o usuário for do tipo Global administrator.
	if (store.getters["UserModule/isGlobalAdministrator"])
	{
		resp = await Controllers.ToolBar.GetGlobalAdministratorMenu();
		toolbarMonitoringElements = resp.data;
		menu = CreateToolBarMenu(toolbarMonitoringElements);
		menu.push(CreateSettingsItem());
	}
	else if (store.getters["UserModule/isCompanyAdministrator"])
	{
		resp = await Controllers.ToolBar.GetToolBarMenu(companyId);
		toolbarMonitoringElements = resp.data;
		menu = CreateToolBarMenu(toolbarMonitoringElements);
		menu.push(CreateSettingsItem());
	}
	else
	{
		resp = await Controllers.ToolBar.GetToolBarMenu(companyId);
		toolbarMonitoringElements = resp.data;
		menu = CreateToolBarMenu(toolbarMonitoringElements);
	}
	store.dispatch(`ToolbarTreeMenuModule/${SET}`, menu);
	return menu;
};

/**
 * Obtém o texto complementar da toolbar para página de aerogeradores.
 * @param {number} monitoringElementId - Id do elemento de monitoramento da turbina.
 * @returns Texto complementar da toolbar para página de aerogeradores.
 */
const GetToolBarComplementaryText = async function(monitoringElementId)
{
	const resp = await Controllers.ToolBar.GetToolBarMonitoringElement(monitoringElementId);
	const monitoringElement = resp.data;
	const windPowerPlantName = monitoringElement.monitoringElementParent.name;
	const windTurbineName = monitoringElement.name;
	return `${windPowerPlantName} • ${windTurbineName}`;
};

export default { GetToolBarTreeMenu, GetToolBarComplementaryText };
